import React, { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

const AnimatedText = ({ lines, duration = 2000 }) => {
  const [animatedLines, setAnimatedLines] = useState([]);
  const { ref, inView } = useInView({ threshold: 0.1 });
  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ /';
  useEffect(() => {
    if (!inView) return;

    const currentLines = lines.map((line) =>
      Array(line.length).fill({ char: ' ', isSpecial: false })
    );
    const intervals = [];

    lines.forEach((line, lineIndex) => {
      line.split('').forEach((targetChar, charIndex) => {
        const isSpecialChar = targetChar === '®';
        const targetIndex = alphabet.indexOf(targetChar);
        let currentIndex = 0;

        if (isSpecialChar) {
          currentLines[lineIndex][charIndex] = { char: targetChar, isSpecial: true };
          return;
        }

        const letterDuration = duration / line.length;
        const stepDuration = letterDuration / alphabet.length;

        intervals.push(
          setInterval(() => {
            currentLines[lineIndex][charIndex] = {
              char: alphabet[currentIndex],
              isSpecial: false,
            };
            setAnimatedLines([...currentLines]);

            if (currentIndex === targetIndex) {
              clearInterval(intervals[intervals.length - 1]);
            } else {
              currentIndex++;
            }
          }, stepDuration)
        );
      });
    });

    return () => intervals.forEach(clearInterval);
  }, [inView, lines, duration, alphabet]);

  return (
    <div ref={ref} className="animated-text-container">
      {animatedLines.map((line, index) => (
        <h1 key={index} className="animated-text">
          {line.map((item, charIndex) =>
            item?.isSpecial ? (
              <span key={charIndex} className="special-char">
                {item.char}
              </span>
            ) : (
              <span key={charIndex}>{item.char}</span>
            )
          )}
        </h1>
      ))}
    </div>
  );
};

export default AnimatedText;